



























































import Loader from '@/contexts/frontend/Loader.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faPencilAlt,
  faTrashAlt,
  faSearch,
  faTimes
} from '@fortawesome/free-solid-svg-icons'

library.add(faPencilAlt, faTrashAlt, faSearch, faTimes)

export default {
  components: {
    loader: Loader
  },
  props: {
    clientId: String
  },
  data: function() {
    return {
      loading: false,
      projects: [],
      projectContains: ''
    }
  },
  mounted() {
    this.loading = true
    this.$api.clientAdmin
      .ListProjects()
      .then(results => (this.projects = results))
      .finally(() => (this.loading = false))
  },
  methods: {
    findProjects() {
      if (this.projectContains.length > 1) {
        this.$api.clientAdmin
          .FindProjects(this.projectContains)
          .then(results => (this.projects = results))
      } else if (this.projectContains.length == 0) {
        this.loading = true
        this.$api.clientAdmin
          .ListProjects()
          .then(results => (this.projects = results))
          .finally(() => (this.loading = false))
      }
    },
    clearSearch() {
      this.projectContains = ''
      this.findProjects()
    }
  },
  computed: {
    projectsFound() {
      return this.projects.length > 0
    },
    hasSearchCriteria() {
      return this.projectContains.length > 0
    }
  }
}
